import React, {useContext, useEffect, useState} from "react";
import useBills from "../../hooks/tosan/useBills";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import EmptyBillCard from "./EmptyBillCard";
import BillCard from "./BillCard";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation} from "swiper";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import {AiOutlineArrowLeft, AiOutlineArrowRight} from "react-icons/ai";
import BillInfoBottomSheet from "./modals/BillInfoBottomSheet";
import {useNavigate} from "react-router-dom";
import editBill from "../../tools/api/tosan/EditBill";
import DataContext from "../../tools/contexts/tosan/DataContext";
import {Reoverlay} from "reoverlay";
import ErrorModal from "./modals/ErrorModal";
import EditBillModal from "./modals/EditBillModal";
import LoadingModal from "./modals/LoadingModal";
import SuccessModal from "./modals/SuccessModal";
import BillInfoModal from "./modals/BillInfoModal";
import ConfirmModal from "./modals/ConfirmModal";
import deleteBill from "../../tools/api/tosan/deleteBill";

const UserBills = ({type, bills, handleGetBills}) => {
    const slideSize = 3;
    const [selectedBills, setSelectedBills] = useState([]);
    const [billLoading, setBillLoading] = useState(true)
    const dataContext = useContext(DataContext)
    const navigate = useNavigate();

    function splitIntoChunks(array, chunkSize = 3) {

        let newArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            let chunk = array.slice(i, i + chunkSize);
            newArray.push(chunk);
        }
        return newArray;
    }

    const handleFilterBills = () => {
        setBillLoading(true)
        if (bills && bills.length > 0) {
            setSelectedBills(splitIntoChunks(bills, slideSize));
        }
        setBillLoading(false)

    }
    useEffect(() => {
        if (bills) {
            handleFilterBills()
        }
    }, [bills])
    const handleShowBillModal = (billInfo) => {

        Reoverlay.showModal(BillInfoModal, {
            billInfo,
            onEdit: () => handleShowEditModal(billInfo),
            onDelete:()=>handleShowDeleteModal(billInfo),
            onInquiry: () => handleInquiry(billInfo)
        })
    }
    const handleShowEditModal = (billInfo) => {
        if (billInfo) {
            Reoverlay.hideModal();
            Reoverlay.showModal(EditBillModal, {
                billInfo,
                type,
                onEdit: handleEditBill,
                onClose: () => {
                    Reoverlay.hideModal()
                }
            })
        }


    }
    const handleShowDeleteModal = (billInfo) => {
        if (billInfo) {
            Reoverlay.hideModal();
            Reoverlay.showModal(ConfirmModal, {
                title: 'حذف قبض',
                icon: <></>,
                description: 'آیا مطمئن هستید؟',
                confirmButtonText: 'حذف ',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonTheme: "danger",
                onConfirm: () => {
                    handleDelete(billInfo.id)
                },
                onCancel: () => {
                    Reoverlay.hideModal();
                }
            })
        }
    }
    const handleDelete = async (id) => {
        Reoverlay.hideModal();
        Reoverlay.showModal(LoadingModal, {text: 'در حال حذف قبض'});
        const response = await deleteBill(dataContext.token, id);

        Reoverlay.hideModal();
        if (response.isOk) {
            handleGetBills()
            Reoverlay.showModal(SuccessModal, {
                title: 'موفق',
                message: 'قبض با موفقیت حذف شد.',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: "بستن",
                cancelButtonTheme: "primary",
                onCancel: () => {
                    Reoverlay.hideModal()
                }
            });

        } else {
            Reoverlay.showModal(ErrorModal, {
                title: "خطا", message: response.message, cancelButtonTheme: "danger", onCancel: () => {
                    Reoverlay.hideModal();
                }
            })
        }

    }
    const handleInquiry = (bill) => {

        if (bill) {
            Reoverlay.hideModal()
            const data = {
                type: bill.bill_type,
                parameter: bill.bill_main_param,
                label: bill.alias,
                serviceType: type
            }
            const params = new URLSearchParams(data);


            navigate(`/tosan/bill?${params.toString()}`)
        }

    }
    const handleEditBill = async (data) => {
        Reoverlay.showModal(LoadingModal, {text: "در حال ویرایش اطلاعات"})
        const response = await editBill(dataContext.token, data);
        Reoverlay.hideAll();
        if (response.isOk) {
            Reoverlay.showModal(SuccessModal, {
                title: 'موفق',
                message: 'اطلاعات قبض با موفقیت ویرایش شد.',
                showCancelButton: true,
                showConfirmButton: false,
                cancelButtonText: "بستن",
                cancelButtonTheme: "primary",
                onCancel: () => {
                    Reoverlay.hideModal()
                }
            })
            handleGetBills()
        } else {
            Reoverlay.showModal(ErrorModal, {
                title: "خطا", message: response.message, cancelButtonTheme: "danger", onCancel: () => {
                    Reoverlay.hideModal();
                }
            })
        }
    }
    SwiperCore.use([Navigation]);


    return <>
        {billLoading && <Skeleton count={3}/>}
        {!billLoading && selectedBills.length > 0 && <div className="w-11/12  relative  mx-auto">
            <Swiper
                // install Swiper modules
                modules={[Navigation]}
                spaceBetween={10}

                breakpoints={
                    {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 3,
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 1,
                            spaceBetween: 3
                        },
                        // when window width is >= 640px
                        640: {
                            slidesPerView: 1,
                            spaceBetween: 3
                        }
                    }
                }
                navigation={{
                    nextEl: '.btn-next-swiper',
                    prevEl: '.btn-prev-swiper',
                }}

                direction="horizontal"
                slidesPerView={1}
            >


                {
                    selectedBills.map((arr, iIndex) => {
                        return <SwiperSlide className="grid  grid-cols-1 gap-2 " key={'arr-' + iIndex}>
                            {arr.map((bill, jIndex) => {
                                return <BillCard serviceType={type} onClick={() => handleShowBillModal(bill)} billInfo={bill}
                                                 key={'bill-' + iIndex + '-' + jIndex}/>
                            })}
                        </SwiperSlide>
                    })
                }
            </Swiper>
            {selectedBills.length > 1 && <>
                <button className="btn-next-swiper">
                    <AiOutlineArrowLeft className=""/></button>
                <button className="btn-prev-swiper ">
                    <AiOutlineArrowRight className=""/></button>
            </>}

        </div>}
        {!billLoading && selectedBills.length === 0 && <EmptyBillCard/>}


    </>
}
export default UserBills;
UserBills.propTypes = {
    type: PropTypes.oneOf(['water', 'tel', 'mobile', 'gas', 'electricity'])
}